module.exports = __webpack_public_path__ + "media/images/payments/payone-dark-2f83d0688d6d39dac1c3751c684af88e.svg";